export const TEXT_SLOGAN = '下载身材觉醒教练端，专业教练即可以轻松管理课程安排，提高工作效率，加强会员服务的专业度。';
export const ALERT_WECHAT_BOUND = '您已经绑定了私人教练，如需绑定新的私人教练，请先和原教练解除绑定。解除绑定的方法：进入潮玩身材觉醒服务号，点击我—我的教练—解除绑定。';
export const ALERT_SHARE_BOUND = (coachName, trainerName) => `${coachName}教练的${trainerName}会员已经完成绑定，如有疑问请和${coachName}教练联系。需要${coachName}教练先和${trainerName}会员解除绑定，您才可以完成这次绑定。`;



// WEBPACK FOOTER //
// ./src/constants/text.js